module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Chapitre Trois")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticClass: "C_FirstWords"
  }, [_vm._v("LACHLAN")]), _vm._v(" posa un sac de glace sur son œil droit avant de s’asseoir sur l’étrange chaise inconfortable de sa gigantesque suite d’hôtel. Il attrapa son téléphone et composa le numéro du conseiller personnel en sécurité de sa famille, Dez, ayant besoin de reprendre le contrôle de la situation.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il faillit sourire, mais son visage était trop douloureux. Ce petit connard de Sheffield avait une sacrée droite.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Surtout pour un petit con. Holden était l’avorton de la nichée, une version miniature de ce cavalier de taureaux qu’Adélaïde avait épousé.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Allô ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Dez. C’est Lachy. T’as un peu de temps ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il n’avait aucune idée de l’heure qu’il était là où se trouvait Dez. Il avait abandonné sa sécurité personnelle il y avait des années, mais Dez semblait toujours avoir le nez fourré dans ses affaires.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Pour toi, mec ? Nan…")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le rire de Dez ressembla à la maison.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Sérieusement, qu’est-ce qui se passe ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— J’ai besoin de tout ce que tu pourras me trouver sur les Sheffield. Ils vont se montrer un peu plus difficiles que ce que je pensais.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Et plus encore. Ce vieil homme et son fusil…")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Pas de problème. Ça ne devrait pas me prendre trop de temps. Je sais qu’ils sont dans le business du rodéo depuis… mince, trois ou quatre générations.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ouais, soupira-t-il. J’ai mis les pieds dans le plat.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ferais-tu preuve de préjugés, Lachy ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Hein ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il opta pour l’innocence, sans être offensé.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— J’imagine. Seulement, je ne veux pas que ma nièce grandisse sur les routes, tu comprends ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Oui, je comprends. Je vais te chercher des munitions, patron. Ne t’inquiète pas.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Merci, Dez. Il me faut un moyen.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sa tête commençait à marteler ; il allait devoir descendre à la petite boutique à la réception et voir ce qu’ils avaient contre les maux de tête.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je vais le trouver. Tu vas bien ? C’est juste le décalage horaire ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— J’ai pris un coup. Le frère du mari d’Ades, j’imagine. Un petit enfoiré.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ça sortit tout seul, ce qui fit rire Lachlan, se surprenant lui-même.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Il doit l’être, s’il a eu le dessus sur toi. Tu peux fanfaronner avec le meilleur d’entre eux.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— J’aime à penser que je ne suis pas mauvais.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Peut-être se ramollissait-il.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Merci, Dez. Passe-moi un coup de fil quand tu auras quelque chose.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je le ferai. Repose-toi.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Merde. Je n’ai rien d’autre à faire que de rester assis.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il détestait l’idée même de se tourner les pouces pendant des jours.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Pourtant, il ne pouvait pas renoncer. C’était la petite fille d’Ades, tout ce qui restait d’elle. Il ne l’avait même pas vue…")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lachlan prit une inspiration. D’accord. Chaque chose en son temps. Il reprit son téléphone et appela le numéro du Ranch Sheffield Inc., qui se trouvait dans ses e-mails, ce qu’il aurait dû faire en premier lieu. Il était parti de la dangereuse hypothèse que ces gens seraient des bouseux qui s’écraseraient et lui remettraient Chloé.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ranch Sheffield. Je suis Kathy. Que puis-je faire pour vous ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Une sœur ? Une secrétaire ? La mère ? Elle ne semblait pas assez âgée pour être la mère.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Bonjour, j’aimerais parler à Holden, s’il vous plaît.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Donnez-moi deux secondes. Hum. Il est noté indisponible dans notre système.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le système ? Ils avaient un système ? Ça ressemblait à son propre fonctionnement.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je peux vous transférer sur son téléphone, cependant, vous pourrez laisser un message. Il est assez bon pour les rappels.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ce serait parfait, merci.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Seigneur, il avait sous-estimé cette famille.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Pas de problème. Passez une bonne journée !")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Une série de clics retentit, puis la voix d’Holden.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Salut. Je travaille ou je dors ou mon téléphone est éteint. Laissez-moi un message et je vous rappellerai bientôt.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Holden. Lachlan McCoughey. Je sais que je n’ai pas fait la meilleure des impressions, mais rappelez-moi. J’aimerais voir Chloé au moins.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il faillit ajouter un ‘s’il vous plaît’, mais il ne put prononcer les mots. Il énonça le numéro du téléphone américain qu’il avait récupéré à l’aéroport.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Maintenant, il allait faire ce qu’il détestait le plus sur Terre.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Attendre.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34f5746a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0007.vue
// module id = 75
// module chunks = 0